import React, { useEffect, useState } from 'react';
import { useLayout } from '../../LayoutContext';
import Header from '../../components/header/Header';
import { VideoStyle } from './formsStyle';
import cornerRightArrow from '../../components/assets/corner-right-down.svg';
import Logo from '../../components/assets/sulamerica-pride.svg';
import videoSource from '../../components/assets/planos-de-saude-pme-empresarial-individual-com-o-melhor-preco-reembolso-carencia.mp4';
import { useNavigate } from 'react-router-dom';
import ProgressBar from '../../components/status/ProgressBar';

const FormVideo = () => {
  sessionStorage.clear();
  const navigate = useNavigate();

  const [progress, setProgress] = useState(1);

  const { setLayoutConfig } = useLayout(); // Usa o hook para acessar a função de configuração

  useEffect(() => {
    // Configura a cor de fundo e o conteúdo do cabeçalho específicos para HomePage
    setLayoutConfig({
      backgroundColor: '#00022D',
      headerContent: {
        // Defina aqui os dados específicos do cabeçalho para a HomePage
      },
    });
  }, [setLayoutConfig]);

  // Estado para controlar a visibilidade do texto adicional
  const [isDropdownOpen, setIsDropdownOpen] = React.useState(false);

  // Função para alternar a visibilidade
  const toggleDropdown = () => {
    setIsDropdownOpen(!isDropdownOpen);
  };

  const handleIndividual = () => {
    const planData = { plan: 'Individual' };
    sessionStorage.setItem('@plan', JSON.stringify(planData));

    navigate('/simulacao/3b');
  };

  const handleFamily = () => {
    const planData = { plan: 'Familiar' };
    sessionStorage.setItem('@plan', JSON.stringify(planData));

    navigate('/simulacao/2');
  };

  const handleCnpjPlan = () => {
    const planData = { plan: 'PME' };
    sessionStorage.setItem('@plan', JSON.stringify(planData));

    navigate('/simulacao/2');
  };

  return (
    <>
      <VideoStyle>
        <section className="formVideo__wrapper col-12">
          <div className="container col-12">
            <div className="logo-form">
              <img className="logo" src={Logo} alt="Logo" height={75} />
            </div>

            <video
              className="video"
              src={videoSource}
              width="800"
              height="400"
              controls
              loop
              muted
            />

            <div className="title__wrapper">
              <h1 className="title">
                Diz aí, qual será a forma de contratação do seu plano de saúde?
              </h1>

              <div className="question__wrapper">
                <p className="text" onClick={toggleDropdown}>
                  Por que essa pergunta?{' '}
                  <img
                    className={`arrow ${isDropdownOpen ? 'up' : ''}`}
                    src={cornerRightArrow}
                    alt="Saiba mais"
                  />
                </p>
                {/* Texto adicional que é mostrado/ocultado baseado no estado */}
                <p
                  className={`dropdown-content ${isDropdownOpen ? 'open' : ''}`}
                >
                  Para personalizar planos de saúde que são ideais para você.
                </p>
              </div>
            </div>

            <div className="buttons__wrapper">
              <a className="button_link" onClick={handleIndividual}>
                <p className="button_text">Plano individual</p>
              </a>

              <a className="button_link" onClick={handleFamily}>
                <p className="button_text">Plano para minha família</p>
              </a>

              <a className="button_link" onClick={handleCnpjPlan}>
                <p className="button_text">Plano através do meu CNPJ</p>
              </a>
            </div>
            <ProgressBar progress={progress} steps={5} />
          </div>
        </section>
      </VideoStyle>
    </>
  );
};

export default FormVideo;
